<script lang="ts">
	import { ActionsContainer, IconButton } from '@Shelly/shelly-design-system/index';
	import { createEventDispatcher } from 'svelte';
	import { format } from 'svelte-i18n';
	import HomeAvatar from 'src/components/Homes/HomeAvatar.svelte';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import { advancedCardComponent } from 'src/stores/advanced_card';
	import type { Home } from 'src/types/Home';

	export let unitId: string;
	export let unitName: string;
	export let home: Home | undefined;
	export let isCurrent: boolean = false;

	const dispatch = createEventDispatcher<{
		edit: { unitId: string };
		delete: { unitId: string };
		transfer: { unitId: string };
	}>();

	$: subtitle = isCurrent
		? {
				value: $format('settings_current_home_label', { default: 'Current home' }),
				icon: 'fas fa-circle-check',
			}
		: { value: '' };

	function handleDelete(): void {
		if (isCurrent) return;
		dispatch('delete', { unitId });
	}
</script>

<div class="unit-item-home-card">
	<svelte:component
		this={$advancedCardComponent}
		title={home?.name ?? unitName}
		{subtitle}
		selected={isCurrent}
	>
		<div class="d-inline-flex pr-s" slot="left">
			<HomeAvatar {home} size="l" />
		</div>
		<ActionsContainer type="simple" slot="right">
			<IconButton
				aria-label={$format('button_edit_unit', { default: 'Edit home' })}
				icon="fas fa-pen"
				variant={$showNewLayout ? 'help-2' : 'primary'}
				slot="first"
				on:click={() => dispatch('edit', { unitId })}
			/>
			<IconButton
				aria-label={$format('button_transfer_unit', { default: 'Transfer home' })}
				icon="fas fa-right-left"
				variant={$showNewLayout ? 'help-2' : 'primary'}
				disabled={isCurrent}
				slot="second"
				on:click={() => dispatch('transfer', { unitId })}
			/>
			<IconButton
				aria-label={$format('button_delete_unit', { default: 'Delete home' })}
				icon="fas fa-trash"
				variant={$showNewLayout ? 'help-2' : 'danger'}
				slot="third"
				disabled={isCurrent}
				on:click={() => handleDelete()}
			/>
		</ActionsContainer>
	</svelte:component>
</div>

<style>
	.unit-item-home-card :global(.advanced-card) {
		overflow: visible;
	}
	.unit-item-home-card :global(.rectangular-avatar-wrapper .avatar-badge) {
		bottom: 0;
		right: 0;
		z-index: 4;
	}
</style>
